module.exports = __webpack_public_path__ + "static/media/PosArrow.dec74c28.svg";